import fetch from "auth/FetchInterceptor";

const AgencyTestCsvService = {};

AgencyTestCsvService.upload = function (payload) {
    return fetch({
        url: "/upload-agency-test-csv",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: payload.formData
    });
};

export default AgencyTestCsvService;